import React, { useState } from 'react';
import { getNameClient } from './../../helpers/nameClient';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Button, Row } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';
import { getFilterListWrNumber } from '../../store/traceabilities/actions';
import './traceabilities.scss';
import { useDispatch, useSelector } from 'react-redux';

export const Traceabilities = () => {
  const dispatch = useDispatch();
  const { listData } = useSelector((state: any) => state.Traceabilities);
  const [message, setMessage] = useState('');

  const handleSearch = () => {
    dispatch(getFilterListWrNumber(message));
  };

  const handleChange = (filter: string) => {
    setMessage(filter);
  };

  const columns = [
    {
      title: '#',
      field: '#',
    },
    {
      title: 'Date',
      field: 'createdAt',
    },
    {
      title: 'Detail 1',
      field: 'text1',
    },
    {
      title: 'Detail 2',
      field: 'text2',
    },
    {
      title: 'Detail 3',
      field: 'text3',
    },
    {
      title: 'Detail 4',
      field: 'text4',
    },
    {
      title: 'Detail 5',
      field: 'text5',
    },
  ];

  return (
    <React.Fragment>
      <PageTitle>
        <title>Traceabilities | {getNameClient()}</title>
      </PageTitle>
      <div id="main">
        <div id="menuColumn"></div>
        <div id="navbar"></div>
        <div id="pageContent">
          <div className="title-page">
            <Breadcrumbs
              title="Traceabilities"
              breadcrumbItem="Traceabilities"
            />
          </div>

          <Row>
            <div className="inputFilter">
              <div className="input-group input-group-lg">
                <span className="input-group-text" id="inputGroup-sizing-lg">
                  WR Number
                </span>
                <input
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-lg"
                  onChange={(e) => {
                    handleChange(e.target.value);
                  }}
                  value={message}
                />
              </div>
            </div>
          </Row>
          <Row>
            <div>
              <Button
                type="button"
                color="primary"
                className="inputBoton"
                onClick={() => {
                  if (message) {
                    handleSearch();
                  }
                }}
              >
                Search
              </Button>
            </div>
          </Row>
          <Row>
            <div className="tableValues">
              <table className="table">
                <thead>
                  <tr>
                    {columns.map((item) => (
                      <th scope="col">{item.title}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {listData.map((item: any, i = 1) => (
                    <tr>
                      <th scope="row">{i + 1}</th>
                      <td>{item.createdAt}</td>
                      <td>{item.text1}</td>
                      <td>{item.text2}</td>
                      <td>{item.text3}</td>
                      <td>{item.text4}</td>
                      <td>{item.text5}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};
